import { Component, OnDestroy, OnInit } from '@angular/core';
import { Breadcrumb } from '@app/models/breadcrumb.model';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from '@app/shared/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-integration-slack-cancellation',
  templateUrl: './integration-slack-cancellation.component.html',
  styleUrls: ['./integration-slack-cancellation.component.css']
})
export class IntegrationSlackCancellationComponent implements OnInit, OnDestroy {

  breadcrumb: Breadcrumb;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute
  ) {
    this.breadcrumb = this.breadcrumbService.init(this.route);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.breadcrumbService.remove(this.breadcrumb);
  }

}


